export const emailIpWarmingAppGroupIdShowIpWarmingWidget = "/email/ip_warming/:app_group_id/show_ip_warming_widget";
